import React, { Component } from 'react';
import './Slideshow.css';

class Slideshow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            lastIndex: -1,
            activeIndex: -1,
            intervalId: -1,
            duration: 10000
        };

        this.imageContainer = [];
        this.imageFiles = [];

    }

    static propTypes =  {
        duration:      React.PropTypes.number.isRequired,
        images:       React.PropTypes.array.isRequired,
        startIndex:      React.PropTypes.number.isRequired,
        className: React.PropTypes.string.isRequired,
    }

    static defaultProps = {
            duration: 5000,
            images: [],
            startIndex: -1,
            className: "SlideShowFixed"
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.images.length > 0) {
            this.initImageFiles(nextProps.images);
        }
    }

    initImageFiles = (images) => {
        if (images.length > 0) {
            ////console.log(("Slideshow - componentWillReceiveProps2: " + images.length);
            clearInterval(this.state.intervalId);
            this.imageFiles = [];
            for (var i=0; i<images.length; i++) {
                var el = images[i];
                if (el.url.indexOf('jpg') !== -1) {
                    this.imageFiles.push(el);
                }
            }

            ////console.log(("Slideshow - componentWillReceiveProps: imageFiles: " + this.imageFiles);

            this.setState({intervalId: -1});
            this.setState({activeIndex: 0});
            this.showImage();
        }
    }

    componentDidMount() {
        if (this.imageFiles.length !== this.props.images.length) {
            this.initImageFiles(this.props.images);
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
        this.setState({intervalId: -1});
    }

    componentDidUpdate() {
        ////console.log(("Slideshow - componentDidUpdate: ");

    };


    nextImage = () => {

        clearInterval(this.state.intervalId);

        if (this.imageFiles.length > 1) {
            var idx = this.state.activeIndex + 1;
            if (idx > this.imageContainer.length-1) {
                idx = 0;
            }

            if (this.imageFiles[idx] !== undefined && this.imageFiles[idx] !== null) {

                this.setState({lastIdx: this.state.activeIndex});
                this.setState({activeIndex: idx});

                this.showImage();
            }
        }

    }

    showImage = () => {

        clearInterval(this.state.intervalId);

        var idx = this.state.activeIndex;

        if (this.imageContainer[idx] !== undefined && this.imageContainer[idx] !== null) {

            ////console.log((" - showImage: " + idx);

            var src = this.imageFiles[idx].url;

            var onComplete = this.onImageLoaded;
            this.imageContainer[idx].onload = function (e) {
                onComplete(idx, e, src);
            }
            this.imageContainer[idx].src = src;

        } else {
            var intervalId = setInterval(this.showImage, 100);
            this.setState({intervalId: intervalId});
        }

    }

    onImageLoaded = (idx, e, src) => {

        for (var i=0; i<this.imageContainer.length; i++) {
            this.imageContainer[i].parentElement.className = this.imageContainer[i].parentElement.className.split("hideSlideShowImage").join("");
            this.imageContainer[i].parentElement.className = this.imageContainer[i].parentElement.className.split("showSlideShowImage").join("");

            if (i === idx) {
                this.imageContainer[i].parentElement.className += 'showSlideShowImage';
            } else {
                this.imageContainer[i].parentElement.className += 'hideSlideShowImage';
            }
        }

        if (this.imageFiles.length > 1) {
            var intervalId = setInterval(this.nextImage, this.props.duration);
            this.setState({intervalId: intervalId});
        }


    }

    onImage = (image) => {
        if (image !== null) {
            this.imageContainer.push(image);
        }
    }

  render() {

    ////console.log(("render - componentDidUpdate: ");

    this.imageContainer = [];

    let k = -1;
    return (
        <div className="SlideShowContainer">
            <div className={this.props.className}>
              {
                  this.imageFiles.map((image) =>
                      <div key={(k++).toString()} className={"ImageContainer hideSlideShowImage"}>
                          <img ref={(d) => { this.onImage(d); }} className="image" src="" alt={image.title}></img>
                      </div>
                  )
              }
          </div>
      </div>
    );
  }
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/components/Slideshow/Slideshow.js